var map = {
	"./IMG_1_PARLAMENTO.png": 6436,
	"./IMG_2_PARLAMENTO.png": 6773,
	"./IMG_3_PARLAMENTO.png": 1606,
	"./IMG_4_PARLAMENTO.png": 5631,
	"./IMG_5_PARLAMENTO.png": 7984,
	"./IMG_6_PARLAMENTO.png": 9345,
	"./IMG_ABRE_PARLAMENTO.png": 3313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6568;